import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import {curry} from 'ramda';

import TableHeaderCell from './TableHeaderCellContainer';
import {ColumnType, Sort, handleSortFn} from '../tableTypes';

interface TableHeaderContainerProps {
    columns: ColumnType[],
    setSort?: handleSortFn,
    sort?: Sort,
}

type getThsArgs = Pick<TableHeaderContainerProps, 'setSort' | 'sort'>

export const getThs = curry((memorizedProps: getThsArgs, th: ColumnType) => {
    const {sort, setSort} = memorizedProps;
    const {
        title,
        sortable,
        dataKey,
        width,
    } = th;

    return (
        <TableHeaderCell
            key={dataKey as string}
            width={width}
            title={title}
            dataKey={dataKey}
            sortable={sortable}
            sort={sort}
            onClick={setSort}
        />
    );
});
export default function TableHeaderContainer({columns, setSort, sort}: TableHeaderContainerProps) {
    const withSorts = getThs({
        sort,
        setSort,
    });
    const headers = columns.map(withSorts);

    return (
        <TableRow className="table__header">
            {headers}
        </TableRow>
    );
}
